import { FC } from 'react'

import ScrollableUserList from 'components/UI/ScrollableUserList'
import { t } from 'translations'

type Props = {
  title: string
  type: string
  usersIds: string[]
}

const CollapsableContent: FC<Props> = ({ title, type, usersIds }) => {
  return (
    <div className="collapse-container my-2 bg-white">
      <div className="link-toggle toggle-header" data-toggle="collapse" data-target={`#${type}`} aria-expanded="false" aria-controls={type}>
        <h6 className="toggle-text align-bottom">
          <b>
            {t(title)} ({usersIds.length})
          </b>
        </h6>
        <i className="fas fa-chevron-up"></i>
        <i className="fas fa-chevron-down"></i>
      </div>
      <ScrollableUserList usersIds={usersIds} containerClass="collapse" id={type} />
    </div>
  )
}

export default CollapsableContent
